import React from 'react'

const MtmLogo = ({
  width = 121,
  height = 32,
  color = 'currentColor',
  responsive = true,
  ...props
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="logoTitle"
      viewBox="0 0 167 48"
      focusable="false"
      {...svgAttributes}
      {...props}
    >
      <title id="logoTitle">Mtm</title>
      <path d="M28.5977 5.0861C31.6509 5.0861 34.2476 5.85222 36.39 7.38554C38.5312 8.91887 39.9766 11.0574 40.7273 13.8011C41.6371 11.1114 43.2581 8.98722 45.5871 7.42633C47.9171 5.86655 50.5807 5.0861 53.5802 5.0861C57.5433 5.0861 60.6492 6.25567 62.8991 8.59589C65.149 10.9361 66.2728 14.2034 66.2728 18.3988V47.122H50.0462V23.8851C50.0462 21.9483 49.7246 20.5638 49.0826 19.7293C48.4395 18.8949 47.421 18.4782 46.0293 18.4782C44.5291 18.4782 43.3646 19.0834 42.5349 20.2937C41.7041 21.5041 41.2892 23.238 41.2892 25.4978V47.1209H25.0626V23.884C25.0626 21.9472 24.741 20.5627 24.099 19.7282C23.4559 18.8938 22.4385 18.4771 21.0457 18.4771C19.5455 18.4771 18.3678 19.0823 17.5107 20.2926C16.6535 21.503 16.2255 23.2369 16.2255 25.4967V47.1198H0V6.05504H14.2193L16.1476 13.8804C17.0036 11.1378 18.5434 8.98612 20.7659 7.42633C22.9872 5.86655 25.5993 5.0861 28.5988 5.0861" fill="currentColor"/>
      <path d="M129.325 5.0861C132.377 5.0861 134.975 5.85222 137.116 7.38554C139.258 8.91887 140.704 11.0574 141.454 13.8011C142.364 11.1114 143.984 8.98722 146.314 7.42633C148.644 5.86655 151.308 5.0861 154.307 5.0861C158.27 5.0861 161.376 6.25567 163.626 8.59589C165.875 10.9361 167 14.2034 167 18.3988V47.122H150.773V23.8851C150.773 21.9483 150.452 20.5638 149.809 19.7293C149.166 18.8949 148.148 18.4782 146.757 18.4782C145.256 18.4782 144.092 19.0834 143.261 20.2937C142.43 21.5041 142.016 23.238 142.016 25.4978V47.1209H125.79V23.884C125.79 21.9472 125.468 20.5627 124.826 19.7282C124.183 18.8938 123.166 18.4771 121.773 18.4771C120.274 18.4771 119.095 19.0823 118.238 20.2926C117.381 21.503 116.954 23.2369 116.954 25.4967V47.1198H100.726V6.05504H114.944L116.873 13.8804C117.728 11.1378 119.268 8.98612 121.491 7.42633C123.712 5.86655 126.323 5.0861 129.324 5.0861" fill="currentColor"/>
      <path d="M87.1756 0L68.4478 13.2521H72.7675V37.5153C72.7675 43.9209 76.1698 47.1221 82.9765 47.1221C85.9826 47.1221 90.0697 46.5378 91.8674 45.3705C94.4224 44.0003 97.0257 41.5189 98.5512 39.149C96.8358 39.7034 94.6013 40.5754 92.5852 41.2996C92.302 41.401 92.0419 41.4903 91.7577 41.5498C90.9389 41.7251 90.0719 41.541 89.3388 41.1188C89.285 41.0879 89.2323 41.0549 89.1807 41.0207C88.4147 40.518 87.8407 39.763 87.5597 38.8877C87.3556 38.2506 87.2535 37.5131 87.2535 36.6731V13.2521H96.9126V11.85H87.2535V0.068344H87.0966L87.1745 0H87.1756Z" fill="currentColor"/>
    </svg>
  )
}

export default MtmLogo